// extracted by mini-css-extract-plugin
export var container = "_7d-0";
export var error = "_7d-9";
export var label = "_7d-5";
export var light = "_7d-6";
export var md = "_7d-3";
export var sm = "_7d-2";
export var thin = "_7d-8";
export var thinBold = "_7d-7";
export var vertical = "_7d-4";
export var xs = "_7d-1";